/**
 * The rotating tip under a wait: a random start, then the next one every few seconds.
 *
 * Owns: which of the `loading.tips.*` strings is showing. Must not: draw it (the
 * loading painting and the radar search each set it in their own capsule).
 */
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import { useI18n } from '@/i18n';

/** Strings in `loading.tips` (en_GB.json). */
const TIP_COUNT = 8;
const TIP_EVERY_MS = 4500;

export function useLoadingTips(enabled: () => boolean) {
  const { t } = useI18n();
  const index = ref(Math.floor(Math.random() * TIP_COUNT));
  let timer = 0;
  onMounted(() => {
    if (enabled()) timer = window.setInterval(() => (index.value = (index.value + 1) % TIP_COUNT), TIP_EVERY_MS);
  });
  onBeforeUnmount(() => window.clearInterval(timer));
  return { index, tip: computed(() => t(`loading.tips.${index.value}`)) };
}
